module.exports = __webpack_public_path__ + "img/hands2.4ed30dac.jpg";